import { TriggerQBOImportRequest, TriggerQBOImportResponse } from "./types";
import axiosInstance from "../axiosInstance";

export const triggerQBOImport = async (
  companyUuid: string,
  request: TriggerQBOImportRequest,
): Promise<TriggerQBOImportResponse> => {
  const response = await axiosInstance.post<{ data: TriggerQBOImportResponse }>(
    `/api/private/companies/${companyUuid}/quickbooks/import`,
    request,
  );
  return response.data.data;
};
